import React from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkPermission, checkTranslation, getObject, setObject } from "../utils/useful";
import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";
import { languagesInfoTranslate } from "../variables/config";

class ItemModal extends React.Component {


    state = {
        // activeLng:
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers) {
            this.init()
        }
    }

    open = () => {
        this.init()
        this.modal.showModal()
    }

    init() {
        this.setState({ headers: this.props.headers, activePage: null, translations: {}, showTranslations: false })
    }

    submitForm = (isApply) => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                if (this.state.translations && Object.keys(this.state.translations).length > 0) {
                    data['**translations'] = this.state.translations
                }

                // console.log(data)
                // return
                this.props.submitForm(data)
            }
        } else {
            this.postValue(isApply)
        }
    }
    hideModal = () => {
        this.modal.hideModal()
    }

    state = {
        countries: [],
        actions: {
            submit: { key: "submit", label: "{{lang}}submit", bgColor: '#677dc4', color: '#fff', function: this.submitForm, loader: "isPostingData" },
            cancel: { key: "cancel", label: "{{lang}}cancel", bgColor: '#9ab', color: '#fff', function: this.hideModal },
        }
    }




    postValue = (isApply) => {
        // console.log("postValue")
        if (this.form) {
            let data = this.form.getForm()




            this.setState({ errors: null })
            let page = this.props.page

            // console.log('daataaaaaaaaaaaaa ==>',data)
            // return
            if (data) {

                if (this.state.translations && Object.keys(this.state.translations).length > 0) {
                    data['**translations'] = { ...this.state.translations }
                }
                // console.log(this.state.translations)
                // console.log(data)
                // // return


                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                if (this.props.convert) {
                    address = page.convertUrl
                }
                data.page = this.props.page?.page ? this.props.page?.page : this.props.page?.key
                if (!isApply) {

                    this.setState({ isPostingData: true })
                } else {
                    this.setState({ isApplyLoader: true })

                }
                // console.log('ccccccccccccccccccccccc', page.postBody)
                if (page.postBody) {
                    let postBody = page.postBody
                    // for (const [key, value] of Object.entries(postBody)) {
                    // }

                    data = { ...postBody, ...data }
                }

                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                    data = setObject(data, key, value)
                }
                // console.log(address)
                // console.log(data)


                // console.log('kkkkkk', JSON.parse(JSON.stringify(data)))
                // console.log('kkkkkk2', data)
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false, isApplyLoader: false })
                    console.log(fetchError)
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    if (!isApply) {

                        this.modal.hideModal()
                    }
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Sent Succesfully', description: '{{lang}}Send Record Succesfully' })
                    //! 
                    if (!isEditing && this.props.itemAdded) {
                        // if (!this.props.convert) {
                        this.props.itemAdded(fetchResult.info, this.props.modalIndex)
                        // } else {
                        //     // setTimeout(() => {'
                        //     if (fetchResult.info._id) {

                        //         if (page.key == 'equipments') {

                        //             let editData = {}
                        //             editData._id = data.rentalEq
                        //             editData.sellEq = fetchResult.info._id
                        //             HttpServices.request('updateRentalSellId', editData, (fResult, fError, fetchStatus) => {
                        //                 console.log(fError)
                        //                 if (fError) {
                        //                     this.setState({ errors: fError.errors })
                        //                     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fError.message })
                        //                     return
                        //                 }
                        //                 this.modal.hideModal()

                        //             })
                        //         } else if (page.key == 'tequipments') {
                        //             let editData = {}
                        //             editData._id = data.sellEq
                        //             editData.rentalEq = fetchResult.info._id
                        //             HttpServices.request('updateSellRentalId', editData, (fResult, fError, fetchStatus) => {
                        //                 console.log(fError)
                        //                 if (fError) {
                        //                     this.setState({ errors: fError.errors })
                        //                     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fError.message })
                        //                     return
                        //                 }
                        //                 this.modal.hideModal()

                        //             })
                        //         }

                        //     }
                        //     // }, 300);

                        // }
                    }

                    if (isEditing && this.props.itemEdited) {
                        // console.log("itemEditedkkkkkkkkkk",fetchResult)
                        console.log(data)
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id, this.props.modalIndex)
                        } else {
                            this.props.itemEdited(data, data._id, this.props.modalIndex)
                        }
                    }
                })
            }
        }
    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }

    itemAdded = () => { }

    itemEdited = () => { }

    showTranslations = (show, lngRef) => {
        // console.log(lngRef)
        let defaultLng = lngRef ?? 'ch'
        let lng = languagesInfoTranslate[defaultLng]
        let lngHeaders = []
        let lngData = {}
        let showTranslations = show != null ? show : !this.state.showTranslations
        this.submitTranslations()

        if (showTranslations) {
            this.setState({ showTranslations: false }, () => {
                if (this.props.page?.headers) {
                    this.props.page.headers.forEach(header => {
                        // console.log(header)
                        if (header.hasTranslation) {
                            lngHeaders.push(header)

                            if (this.props.initData) {
                                if (!this.props.initData['**translations']) {
                                    this.props.initData['**translations'] = {}
                                }

                                if (!this.props.initData['**translations'][defaultLng]) {
                                    this.props.initData['**translations'][defaultLng] = {}
                                }

                                // console.log(this.state.translations)
                                // console.log(defaultLng)
                                // if (this.state.translations) {
                                //     console.log(this.state.translations[defaultLng])
                                // }
                                // console.log(header.key)

                                if (this.state.translations && this.state.translations[defaultLng]) {
                                    // lngData[header.key] = this.state.translations[defaultLng][header.key]
                                    // lngData[header.key] = getO this.state.translations[defaultLng][header.key]
                                    let myValue = getObject(this.state.translations[defaultLng], header.key) //this.props.initData['**translations'][defaultLng][header.key]
                                    setObject(lngData, header.key, myValue)

                                } else {
                                    // lngData[header.key] = this.props.initData['**translations'][defaultLng][header.key]
                                    let myValue = getObject(this.props.initData['**translations'][defaultLng], header.key) //this.props.initData['**translations'][defaultLng][header.key]
                                    setObject(lngData, header.key, myValue)
                                }
                            }
                        }
                    });
                }
                console.log(lngHeaders)
                console.log(lngData)

                this.setState({ lngData, lngHeaders, showTranslations: showTranslations, activeLng: lng })
            })

        } else {
            this.setState({ showTranslations })

        }
    }

    submitTranslations = (close) => {
        if (this.translationForm) {
            let data = this.translationForm.getForm()
            let translations = this.state.translations
            let lng = this.state.activeLng?.shortName
            if (!translations) {
                translations = {}
            }

            if (lng) {
                if (!translations[lng]) {
                    translations[lng] = {}
                }

                translations[lng] = data

                console.log(translations)

                this.setState({ translations })
            }
            if (close) {
                this.setState({ showTranslations: false })
            }
        }
    }

    submitBtn = () => {
        let submit = { key: "submit", label: "{{lang}}submit", color: '#fff', function: this.submitForm, loader: "isPostingData" }
        if (submit.key !== 'submit' || !this.props.variables?.permissionRoot || (!this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.create')) || (this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.edit')))
            return (
                <div className="flexc" style={{ flexDirection: 'row-reverse' }}>

                    <LoaderButton
                        onClick={submit.function}
                        isLoading={this.state[submit.loader]}
                        text={checkTranslation(submit.label)}
                        type={"Oval"}
                        className="flexc mx-1 flexcc"
                        buttonStyle={{ height: 30, background: '#FAF8F8', borderRadius: 20, padding: '8px 15px', display: 'flex', alignItems: 'center', fontWeight: '550', textTransform: 'uppercase' }}
                        width={40}
                        height={40}
                        color={'#FAF8F8'}
                    />
                    <LoaderButton
                        onClick={() => this.submitForm(true)}
                        isLoading={this.state.isApplyLoader}
                        text={checkTranslation('{{lang}}apply')}
                        type={"Oval"}
                        className="flexc mx-1 flexcc"
                        buttonStyle={{ height: 30, background: '#FAF8F8', borderRadius: 20, padding: '8px 15px', display: 'flex', alignItems: 'center', fontWeight: '550', textTransform: 'uppercase' }}
                        width={40}
                        height={40}
                        color={'#FAF8F8'}
                    />
                </div>
            )
    }



    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={800}>
                <div className="pb-5 w-100 h-100">

                    {this.props.showDates && this.props?.initData?._id && (
                        <div className="flexc  px-2">
                            <p className="text-small" style={{ color: '#00000050' }}>Create Date: {moment(this.props.initData?.cDate).format('YYYY MMMM DD')}</p>
                            <p className="text-small mld-4" style={{ color: '#00000050' }}>Update Date: {moment(this.props.initData?.uDate).format('YYYY MMMM DD')}</p>
                        </div>
                    )}
                    <p className="text-small mb-2  px-2" style={{ color: '#00000050' }}>{this.props.initData?._id}</p>


                    <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                        <div className="w-100" style={{ zIndex: 10, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8f0', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', borderRadius: '8px 8px 0px 0px' }}>
                            <div className="flexc">
                                <div>
                                    <p>{(this.props.title ?? (this.props?.initData?._id ? "Edit" : "Add"))}</p>

                                </div>

                                {this.props.page?.hasTranslation && (
                                    <button onClick={() => this.showTranslations()} className="px-2 py-2 mx-2" style={{ backgroundColor: this.state.showTranslations ? '#677dc4' : '#fff', color: this.state.showTranslations ? '#fff' : '#000', borderRadius: 40 }}>
                                        <p>Translations</p>
                                    </button>
                                )}
                            </div>

                            <div className="flexc">
                                {/* <button onClick={() => this.ConfigurationDone()} className=" flexc px-3 mx-1 flexcc" style={{ height: 30, background: '#ffffff50', borderRadius: 20 }}>
                                    <p className="text-normal">Done</p>
                                </button> */}
                                {this.submitBtn()}

                                <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                </div>
                            </div>




                        </div>
                        {/* <div className="px-4 py-2">
                            <p className="text-small" style={{color:'#789'}}>Create Date: {moment(this.props.initData?.cDate).format('YYYY MMMM DD')}</p>
                            <p className="text-small" style={{color:'#789'}}>Update Date: {moment(this.props.initData?.uDate).format('YYYY MMMM DD')}</p>
                        </div> */}
                        {!this.state.showTranslations && (
                            <div>
                                {this.props.page?.pages && (
                                    <div className="w-100 flexc mb-2">

                                        <div className="ml-0 text-center" onClick={() => { this.changePage(null) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.activePage == null ? '#677dc4' : '#9ab', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                            <p>Details</p>
                                        </div>

                                        {this.props.page.pages.map((prop, index) => {
                                            return (
                                                <div className="ml-0 text-center" onClick={() => { this.changePage(index, prop) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', borderLeft: '1px solid #89a', transition: 'all 0.3s', backgroundColor: this.state.activePage == index ? (prop.tabColor ?? '#677dc4') : '#9ab', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                                    <p>{prop.title}</p>
                                                </div>)
                                        })}

                                    </div>
                                )}

                                {!this.props.hideForm && (
                                    <div className="py-3 px-4">
                                        <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                    </div>
                                )}


                                <div className="flexc px-3 pb-3">
                                    {Object.values(this.state.actions).map((prop, index) => {
                                        if (prop.key != 'submit' || (!this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.create')) || (this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.edit')))
                                            return (
                                                <div key={index} className="w-100 mx-1">

                                                    <LoaderButton
                                                        onClick={prop.function}
                                                        isLoading={this.state[prop.loader]}
                                                        text={checkTranslation(prop.label)}
                                                        type={"Oval"}
                                                        className="text-bold text-small text-uppercase w-100"
                                                        buttonStyle={{ outline: 'none', width: '100%', backgroundColor: prop.bgColor, cursor: 'pointer', padding: '13px 20px', borderRadius: 8, textTransform: 'uppercase', fontSize: 15, fontWeight: 'bold', color: prop.color, border: 'none' }}
                                                        width={40}
                                                        height={40}
                                                        color={prop.bgColor}
                                                    />
                                                </div>
                                            )
                                    })}
                                </div>
                            </div>
                        )}


                        {this.state.showTranslations && (
                            <div>

                                {languagesInfoTranslate && (
                                    <div className="w-100 mb-3" style={{ position: 'relative'}}>
                                        <div
                                            className="dropdown-toggle"
                                            style={{
                                                backgroundColor: '#5b6ac9',
                                                color: '#fff',
                                                padding: '10px 16px',
                                                borderRadius: 6,
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                            }}
                                            onClick={() => this.setState({ showLangDropdown: !this.state.showLangDropdown })}
                                        >
                                            {this.state.activeLng?.name || 'Select Language'}
                                        </div>

                                        {this.state.showLangDropdown && (
                                            <div
                                                className="dropdown-menu"
                                                style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    zIndex: 10,
                                                    background: '#fff',
                                                    border: '1px solid #ccc',
                                                    borderRadius: 6,
                                                    marginTop: 4,
                                                    width: '100%',
                                                    maxHeight: 250,
                                                    overflowY: 'auto',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                }}
                                            >
                                                {Object.values(languagesInfoTranslate).map((prop) => {
                                                    const isActive = this.state.activeLng?.shortName === prop.shortName;
                                                    return (
                                                        <div
                                                            key={prop.shortName}
                                                            onClick={() => {
                                                                this.setState({ showLangDropdown: false });
                                                                this.showTranslations(true, prop.shortName);
                                                            }}
                                                            className="lang-tab"
                                                            style={{
                                                                fontSize: 14,
                                                                padding: '10px 16px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #eee',
                                                                backgroundColor: isActive ? '#5b6ac9' : '#fff',
                                                                color: isActive ? '#fff' : '#333',
                                                                transition: 'all 0.2s ease',
                                                            }}
                                                        >
                                                            {prop.name}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}


                                {this.state.lngHeaders && (
                                    <div className="py-3 px-4">
                                        <FormViewer ref={el => this.translationForm = el} headers={this.state.lngHeaders} initData={this.state.lngData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                    </div>
                                )}


                                <div className="w-100 mx-1 mb-5 px-4">

                                    <LoaderButton
                                        onClick={() => this.submitTranslations(true)}
                                        isLoading={false}
                                        text={'Submit Translations'}
                                        type={"Oval"}
                                        className="text-bold text-small text-uppercase w-100"
                                        buttonStyle={{ outline: 'none', width: '100%', backgroundColor: 'rgb(103, 125, 196)', cursor: 'pointer', padding: '13px 20px', borderRadius: 8, textTransform: 'uppercase', fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                                        width={40}
                                        height={40}
                                        color={'rgb(103, 125, 196)'}
                                    />
                                </div>


                            </div>
                        )}
                    </div>


                </div>
            </Modal>
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(ItemModal);
